export enum ACLRole {


    COMPANY_MANAGER         = 1,


    PROJECT_FULL_ACCESS     = 100,



    TASK_CREATOR            = 200

}